import { render } from "./DgWohnungStep8b.vue?vue&type=template&id=404516c6&scoped=true"
import script from "./DgWohnungStep8b.vue?vue&type=script&lang=js"
export * from "./DgWohnungStep8b.vue?vue&type=script&lang=js"

import "./DgWohnungStep8b.vue?vue&type=style&index=0&id=404516c6&scoped=true&lang=css"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-404516c6"]])

export default __exports__